export const TRANSLATE = 'CARD_TRANSLATE_TRANSLATE';
export const SHOW_ORIGINAL = 'CARD_TRANSLATE_SHOW_ORIGINAL';

/**
 * Dispatch action to read the open card in `lang`.
 * @param {String} cardId Card to translate.
 * @param {String} lang Kerika language code the reader picked, e.g. `'hi'`.
 */
export const translate = (cardId, lang) => {
  return {
    type: TRANSLATE,
    cardId,
    lang
  }
}

/**
 * Dispatch action to put the author's words back on the card.
 * @param {String} cardId Card to stop translating.
 */
export const showOriginal = (cardId) => {
  return {
    type: SHOW_ORIGINAL,
    cardId
  }
}
